<template>
  <div class="news-detail">
    <div class="title-m">
      <span @click="returnList">新闻动态</span>
      <i class="el-icon el-icon-caret-left"></i>
      <span>正文</span>
    </div>
    <div class="content-m">
      <div class="con-title">{{info.NewsTitle}}</div>
      <div class="con-time">{{UtilService.DateFormat(info.PublishTime)}}</div>
      <div class="con-html" v-html="info.NewsContent"></div>
    </div>
  </div>
</template>

<script>
import { CompService } from '/@/service'
import { UtilService } from '/@/libs'

export default {
  props: {
    newId: { default: '' }
  },
  data() {
    return {
      info: {},
      UtilService,
    }
  },
  mounted() {
    this.getNewsInfo();
  },
  methods: {
    returnList() {
      this.$emit('returnList');
    },
    async getNewsInfo() {
      if(!this.newId) return;
      const res = await CompService.getNewsInfo(this.newId);
      if (res) {
        this.info = res || {};
      }
    }
  }
}
</script>

<style lang="less" scoped>
.news-detail{
  width: 824px;
  margin: 0 auto;
  .title-m{
    font-size: 14px;
    display: flex;
    align-items: center;
    color: @text-color-call-out;
    span:first-child{
      color: @a-color-active;
      cursor: pointer;
    }
    /deep/ .el-icon{
      font-size: 12px;
    }
  }
  .content-m{
    width: 100%;
    padding: 30px 50px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
    margin-top: 10px;
  }
  .con-title{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    text-align: center;
  }
  .con-time{
    font-size: 14px;
    color: #333333;
    text-align: center;
    border-bottom: 1px solid #DADADA;
    padding: 10px 0 20px 0;
  }
  .con-html{
    /deep/ img{
      max-width: 100%;
    }
  }
}
</style>